/**
 * Конфіг СВІТУ для інстансу sd — «Кодекс Давокару» (Symbaroum × Daggerheart).
 * Навігація будується з контенту (navSource:'content'), бо БД має багату
 * структуру з UA-лейблами. Той самий движок, що й nw.
 */
import { CATEGORY_TREE, type CatNode } from './categories.js';

export interface NavItem { key: string; label: string; to: string; gm?: boolean }
export interface CreateType { label: string; type: string; tree: string; category: string; icon: string }

export interface WorldConfig {
  brandName: string;
  brandSub: string;
  nav: NavItem[];
  navSource: 'canonical' | 'content';
  navTree: CatNode[];
  createTypes: CreateType[];
}

export const WORLD: WorldConfig = {
  brandName: 'Кодекс Давокару',
  brandSub: 'Symbaroum × Daggerheart',
  nav: [
    { key: 'world', label: 'Світ', to: '/wiki' },
    { key: 'wiki', label: 'Вікі', to: '/wiki/_/world' },
    { key: 'campaigns', label: 'Книги', to: '/wiki/_/campaign' },
    { key: 'combat', label: 'Бій', to: '/battle' },
  ],
  navSource: 'content',
  navTree: CATEGORY_TREE,
  createTypes: [
    { label: 'NPC / персонаж', type: 'npc', tree: 'npcs', category: 'Персонажі', icon: 'npc' },
    { label: 'Ворог (бестіарій)', type: 'adversary', tree: 'adversaries/bestiary', category: 'Бестіарій', icon: 'beast' },
    { label: 'Локація', type: 'location', tree: 'locations', category: 'Локації', icon: 'location' },
    { label: 'Фракція', type: 'faction', tree: 'factions', category: 'Фракції', icon: 'faction' },
    { label: 'Предмет / артефакт', type: 'item', tree: 'items', category: 'Предмети', icon: 'item' },
    { label: 'Розділ книги', type: 'lore', tree: 'campaign', category: 'Книги', icon: 'campaign' },
    { label: 'Лор / запис', type: 'lore', tree: 'lore', category: 'Лор', icon: 'lore' },
  ],
};

export function iconForPath(path: string): string {
  const p = path.toLowerCase();
  const has = (...k: string[]): boolean => k.some((s) => p.includes(s));
  if (has('campaign', 'book', 'ep', 'кампан', 'книг')) return 'campaign';
  if (has('act', 'акт', 'quest', 'квест', 'scenario', 'сценар')) return 'quest';
  if (has('npc', 'персонаж', 'denizen', 'inhabitant', 'keeper', 'cleric', 'merchant', 'scholar', 'autorit', 'влад')) return 'npc';
  if (has('adversar', 'bestiar', 'бестіар', 'противник', 'monster', 'beast', 'spider', 'troll')) return 'beast';
  if (has('faction', 'фракц', 'clan', 'клан', 'order', 'pact', 'church', 'церкв')) return 'faction';
  if (has('item', 'artifact', 'артефакт', 'предмет', 'weapon', 'зброя', 'potion', 'elixir', 'зіл', 'еліксир', 'herb', 'equip', 'споряд')) return 'item';
  if (has('mechanic', 'механік', 'abilit', 'здібн', 'power', 'сил', 'ritual', 'ритуал', 'trait', 'рис', 'boon', 'burden', 'благ', 'тягар', 'tradition', 'традиц', 'class')) return 'ability';
  if (has('city', 'місто', 'hold', 'голд', 'yndaros', 'йондар', 'karvosti', 'карвост', 'thistle', 'тістл', 'district', 'район', 'tavern', 'таверн', 'inn', 'готел', 'shop', 'магазин')) return 'city';
  if (has('location', 'локац', 'davokar', 'давокар', 'alberetor', 'альберетор', 'place')) return 'location';
  if (has('geograph', 'геогр', 'region', 'регіон', 'environment', 'середовищ')) return 'region';
  if (has('histor', 'істор', 'event', 'подія', 'поді', 'timeline', 'хронолог')) return 'lore';
  if (has('cosmo', 'космо', 'deit', 'бог', 'божеств', 'spirit', 'дух', 'myth', 'міф')) return 'deity';
  if (has('race', 'рас', 'people', 'народ', 'culture', 'культур', 'elf', 'ельф', 'profession', 'професі', 'archetyp', 'архетип')) return 'people';
  if (has('secret', 'секрет')) return 'lore';
  if (has('lore', 'лор', 'concept', 'історичн')) return 'lore';
  if (has('world', 'світ')) return 'world';
  return 'document';
}

const CAT_CYCLE = ['cat-world', 'cat-city', 'cat-location', 'cat-people', 'cat-faction', 'cat-character', 'cat-lore', 'cat-item', 'cat-campaign', 'cat-quest', 'cat-deity', 'cat-ability'];
export function catForIndex(i: number): string {
  return CAT_CYCLE[i % CAT_CYCLE.length]!;
}
